import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { navigate } from '../../lib/router.svelte.ts';
import { getSettings, updateSettings } from '../../lib/stores/settings.svelte.ts';
import { getActiveChildren } from '../../lib/stores/children.svelte.ts';
import ChildSwitcher from './ChildSwitcher.svelte';

var root_1 = $.from_html(`<button class="back-btn svelte-3bv9y2r3ru477" aria-label="Go back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="svelte-3bv9y2r3ru477"><path d="M15 18l-6-6 6-6" class="svelte-3bv9y2r3ru477"></path></svg></button>`);
var root_2 = $.from_html(`<span class="brand-name svelte-3bv9y2r3ru477">mamaobaby</span>`);
var root_5 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="svelte-3bv9y2r3ru477"><circle cx="12" cy="12" r="4" class="svelte-3bv9y2r3ru477"></circle><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" class="svelte-3bv9y2r3ru477"></path></svg>`);
var root_6 = $.from_svg(`<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" class="svelte-3bv9y2r3ru477"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" class="svelte-3bv9y2r3ru477"></path></svg>`);
var root = $.from_html(`<header class="top-bar safe-top svelte-3bv9y2r3ru477"><div class="top-bar-inner svelte-3bv9y2r3ru477"><div class="top-left svelte-3bv9y2r3ru477"><!> <button class="brand svelte-3bv9y2r3ru477" aria-label="mamaobaby home"><div class="logo-circle svelte-3bv9y2r3ru477"><svg viewBox="0 0 24 24" width="16" height="16" class="svelte-3bv9y2r3ru477"><path d="M12 3C10 7 6 9 6 13a6 6 0 0012 0c0-4-4-6-6-10z" fill="white" opacity="0.9" class="svelte-3bv9y2r3ru477"></path><path d="M12 3c2 4 6 6 6 10" stroke="white" stroke-width="1.2" stroke-linecap="round" opacity="0.5" class="svelte-3bv9y2r3ru477"></path></svg></div> <!></button> <!></div> <div class="top-right svelte-3bv9y2r3ru477"><!> <button class="btn-donate svelte-3bv9y2r3ru477" aria-label="Donate to support mamaobaby"><span class="donate-heart svelte-3bv9y2r3ru477">♥</span> Donate</button> <button class="btn-theme svelte-3bv9y2r3ru477" aria-label="Toggle dark mode"><!></button></div></div></header>`);

function TopBar($$anchor, $$props) {
	$.push($$props, true);

	let showBack = $.prop($$props, 'showBack', 3, false),
		backPath = $.prop($$props, 'backPath', 3, '/');

	const settings = $.derived(getSettings);
	const isDark = $.derived(() => $.get(settings).theme === 'dark');
	const showSwitcher = $.derived(() => getActiveChildren().length > 1);

	function toggleTheme() {
		updateSettings({ theme: $.get(isDark) ? 'light' : 'dark' });
	}

	var header = root();
	var div = $.child(header);
	var div_1 = $.child(div);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var button = root_1();

			$.delegated('click', button, () => navigate(backPath()));
			$.append($$anchor, button);
		};

		$.if(node, ($$render) => {
			if (showBack()) $$render(consequent);
		});
	}

	var button_1 = $.sibling(node, 2);
	var node_1 = $.sibling($.child(button_1), 2);

	{
		var consequent_1 = ($$anchor) => {
			var span = root_2();

			$.append($$anchor, span);
		};

		$.if(node_1, ($$render) => {
			if (!$.get(showSwitcher)) $$render(consequent_1);
		});
	}

	$.reset(button_1);

	var node_2 = $.sibling(button_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var fragment = $.comment();
			var node_3 = $.first_child(fragment);

			ChildSwitcher(node_3, {});
			$.append($$anchor, fragment);
		};

		$.if(node_2, ($$render) => {
			if ($.get(showSwitcher)) $$render(consequent_2);
		});
	}

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_4 = $.child(div_2);

	{
		var consequent_3 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_5 = $.first_child(fragment_1);

			$.snippet(node_5, () => $$props.children);
			$.append($$anchor, fragment_1);
		};

		$.if(node_4, ($$render) => {
			if ($$props.children) $$render(consequent_3);
		});
	}

	var button_2 = $.sibling(node_4, 2);
	var button_3 = $.sibling(button_2, 2);
	var node_6 = $.child(button_3);

	{
		var consequent_4 = ($$anchor) => {
			var svg = root_5();

			$.append($$anchor, svg);
		};

		var alternate = ($$anchor) => {
			var svg_1 = root_6();

			$.append($$anchor, svg_1);
		};

		$.if(node_6, ($$render) => {
			if ($.get(isDark)) $$render(consequent_4); else $$render(alternate, -1);
		});
	}

	$.reset(button_3);
	$.reset(div_2);
	$.reset(div);
	$.reset(header);
	$.delegated('click', button_1, () => navigate('/'));
	$.delegated('click', button_2, () => navigate('/donate'));
	$.delegated('click', button_3, toggleTheme);
	$.append($$anchor, header);
	$.pop();
}

if (import.meta.hot) {
	TopBar = $.hmr(TopBar);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3bv9y2r3ru477');
		TopBar[$.HMR].update(module.default);
	});
}

export default TopBar;

$.delegate(['click']);
import "bun-svelte:TopBar.svelte-1ri4iozf7qbi4-style.css";